import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import withLocation from '../withLocation'
import { PrimaryButton } from '@mmsg/louie'
import BannerMainImageSection from '../bannerMainImageSection'
import Layout from '../../layout'
import { useHistory } from 'react-router-dom'
import globals from 'application/constants/globals'

const RequestCancellationPage = ({ isAuthenticated, opportunityId }) => {
  useEffect(() => {
    if (!isAuthenticated) {
      if (opportunityId) {
        window.location.href = '/login?oppId=' + opportunityId
      } else {
        window.location.href = '/login'
      }
    }
  }, [isAuthenticated, opportunityId])

  let history = useHistory()
  return (
    <Layout>
      <div id="page" className="banner-estimate-bg">
        <BannerMainImageSection imageName={globals.isBrandMX ? 'Banner2' : ''}>
          <h2 className="mt-4 banner-content text-center">
            Your request for cancellation has been submitted.
          </h2>
        </BannerMainImageSection>
        <Container className="section mb-5">
          <div className="mt-5 mb-3 text-center">
            <PrimaryButton
              onClick={() => {
                history.push('/estimates')
              }}
              extendInMob
              id="requestcancellationpage.backtoestimates"
            >
              Back to estimates
            </PrimaryButton>
          </div>
        </Container>
      </div>
    </Layout>
  )
}

function mapStateToProps(state, ownProps) {
  const { isAuthenticated, opportunityId } = state.authentication

  return {
    isAuthenticated,
    opportunityId,
  }
}

export default connect(mapStateToProps)(withLocation(RequestCancellationPage))
